import styled from '@emotion/styled';
import { ContentText, ContentTitle } from '../CardItem/styled';

export const Text = styled(ContentText)`
  white-space: normal;
`;

export const Title = styled(ContentTitle)`
  white-space: normal;
`;
